import React from 'react';
import { InternalAuditorTemplate } from '../components/training/templates/InternalAuditorTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getInternalAuditorContent } from '../data/standards/trainingContent';

export const ISO27001InternalAuditor = () => {
  const standard = getStandardBySlug('iso-27001');
  const content = getInternalAuditorContent('iso-27001');

  return <InternalAuditorTemplate standard={standard} content={content} />;
};
